import dayjs from 'dayjs';

import {timestampToDate} from 'ultra/helpers/date'
import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity, getClientEnv, getClientImageUrl, getClientDefaultImageUrl} from 'ultra/configs/general';

import {useNavigationStore} from '../../../../../../../../Stores/navigation'

import LinksTile from '../../../../../../Widgets/LinksTile'
import LinksTileWithCategories from '../../../../../../Widgets/LinksTileWithCategories'
import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import TopPagePicture from '../../../../../../Widgets/TopPagePicture'

import './index.scss'

function scamTitle(item) {
    let username
    // telegram_id
    if (item.username) {
        username = '@' + item.username
    }

    let id
    if (item.telegram_id) {
        id = item.telegram_id
    }

    const date = dayjs(new Date(timestampToDate(item._created))).format('YYYY-MM-DD HH:mm')

    return <span className='titleWrap'>
        {username && <span className='title'>{username}</span>}
        {id && !username && <span className='title'>{id}</span>}
        {date && !id && !username && <span className='title'>{date}</span>}

        {id && username && <span className='id'>{id}</span>}
        {date && (id || username) && <span className='date'>{date}</span>}        
    </span>
}

export default function Template(props) {
    const {content, config, children, permits, breadcrumbs} = props

    const {contentLoading} = useNavigationStore()

    let hasCategories = false
    children.order.map(id => {
        if (hasCategories) return;

        if (children.list[id].category) {
            hasCategories = true;
        }
    })

    const getScumCover = (item) => {
        const env = getClientEnv(window);
        if (item.cover) {
            const imgCity = getClientCity(window) || DEFAULT_CITY;
            return {
                src: getClientImageUrl(env, imgCity, item.cover),
                className: 'thumbnail'
            }
        }
        else if (item.thumbnail) {
            return {
                src: getClientImageUrl(env, DEFAULT_CITY, item.thumbnail),
                className: 'thumbnail'
            }
        }
        else if (item?.gallery?.[0]) {
            const imgCity = getClientCity(window) || DEFAULT_CITY;
            return {
                src: getClientImageUrl(env, imgCity, item.gallery[0]),
                className: 'thumbnail'
            }
        } else {
            return {
                src: getClientDefaultImageUrl(window, `config/images/default/thumbnail.png`),
                className: 'thumbnail'
            }
        }
    }

    return <div className='ScamersTemplate'>
        <TopPagePicture cutHeightForDesktop image={content.banner} hidden={config?.templateOptions?.topPagePictureHidden}/>
        {/* showSkeleton={contentLoading}  */}

        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {config?.templateOptions?.descriptionPosition !== 'bottom' && <CKEditorContent content={content.description} />}

        {(!hasCategories && !config.categories) && <LinksTile
            xs={6} md={3}
            imgLoading={config?.templateOptions?.imgLoading}
            showFilters={config?.showFilters || content?.showFilters}
            showSkeleton={contentLoading}
            showPagination={content.showPagination}
            links={children}
            src={getScumCover}
            isExternalLinksSection={config?.templateOptions?.isExternalLinksSection}
            title={scamTitle}
            sharedImages
        />}

        {(hasCategories || config.categories) && <LinksTileWithCategories
            xs={6} md={3}
            permits={permits}
            
            categoriesConfig={config.categories}
            showFilters={config?.showFilters || content?.showFilters}
            showSkeleton={contentLoading}
            links={children}
            src={getScumCover}
            isExternalLinksSection={config?.templateOptions?.isExternalLinksSection}

            sharedImages
        />}

        {config?.templateOptions?.descriptionPosition === 'bottom' && <CKEditorContent content={content.description} />}
    </div>
}
